import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { TopPanel, ActionBar, ExportButton } from '../common';
import { BwicCreator } from '.';
import { Table } from '../common/table';
import { brokerDealerCanceledColumns } from '../common/table/columns';
import { brokerDealerAccessState } from '../../../constants/bidding';
import { ControlPanel } from '../common/ControlPanel';
import { CompanyDetailsPanel } from '../../company-details/CompanyDetailsPanel';
import { RequestSettlementAgentAgreementBanner } from '../../request-settlement-agent-agreement/RequestSettlementAgentAgreementBanner';
import { AppState } from '../../../types/state/AppState';
import { BwicPosition } from '../../../types/bwic/BwicPosition';

interface CanceledProps {
    activePositionId?: number;
}

export const Cancelled = ({ activePositionId }: CanceledProps) => {

    const bwic = useSelector((s: AppState) => s.bidding.bwic);
    const securities = useSelector((s: AppState) => s.brokerDealerBidding.securities);
    const accessState = useSelector((s: AppState) => s.brokerDealerBidding.accessState);

    const createSecurityCustomClassName = (security: BwicPosition) => {
        return classNames('tradedaway', {
            active: security.id === activePositionId
        });
    };

    return (
        <div className="container bidding-cnt">
            <div className="sub-header">
                <TopPanel bwic={bwic}>
                    {bwic.seller && <BwicCreator seller={bwic.seller} />}
                    <div className="flex-item-right controls">
                        <ActionBar>
                            {accessState === brokerDealerAccessState.approved && <ExportButton bwicReferenceName={bwic.referenceName} />}
                        </ActionBar>
                    </div>
                </TopPanel>
            </div>
            {bwic.isAllToAll && <RequestSettlementAgentAgreementBanner />}
            <div className="flex-row flex-row-full-size">
                <Table
                    className="data-list-striped data-list-bd-cancelled"
                    dataItems={securities}
                    columns={brokerDealerCanceledColumns}
                    createSecurityCustomClassName={createSecurityCustomClassName}
                />
                <ControlPanel
                    bwic={bwic}
                    positions={securities}
                    showEvalValues={true}
                />
                <CompanyDetailsPanel />
            </div>
        </div>
    );
}
